// src/components/visits/VisitCheckWarningToast.jsx
//
// Non-blocking warning shown after visit check created material exceptions.
// =============================================================================
//
// PURPOSE
// -------
// The salon employee must not be forced to solve stock shortages while simply
// checking a completed visit. This component communicates the important fact
// without interrupting the workflow:
//
//   "Visit was checked, but some material consumption needs manager review."
//
// It intentionally renders a small message and not a blocking modal.

import React from "react";
import { useTranslation } from "react-i18next";

const VisitCheckWarningToast = ({ warning, summary }) => {
  const { t } = useTranslation(["visits"]);

  if (!warning) return null;

  const exceptions = Number(summary?.exceptions || 0);

  return (
    <div className="mp-toast mp-toast--warning" role="status">
      <strong>{warning}</strong>
      {exceptions > 0 ? (
        <span className="mp-toast__detail">
          {t("visits:managePage.materialLinesNeedReview", { count: exceptions, defaultValue: `${exceptions} material line${exceptions === 1 ? "" : "s"} need review.` })}
        </span>
      ) : null}
    </div>
  );
};

export default VisitCheckWarningToast;
